// Room temperature for a reading: the room probe where the device has one,
// otherwise the mean of its two probes (the same "actual internal temperature"
// the forecast view shows).
export function roomTemperature(r) {
    if (r.room_temperature != null) return r.room_temperature;
    const probes = [r.flow_temperature, r.return_temperature].filter(t => t != null);
    return probes.length ? Math.round((probes.reduce((a, b) => a + b, 0) / probes.length) * 100) / 100 : null;
}

